/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { getStyleOverrides } from '@/utils/getStyleOverrides';
import { ThemeOptions } from '@mui/material/styles';

export const TextField: ThemeOptions = {
	components: {
		MuiInputLabel: {
			styleOverrides: {
				outlined: getStyleOverrides({
					styles: {
						transform: 'none',
						position: 'relative',
						mb: 1,
						pointerEvents: 'unset',

						'&.Mui-focused:not(.Mui-error)': {
							color: 'text.primary',
						},
						color: 'text.secondary',
						'&.Mui-focused': {
							color: 'text.primary',
						},
						'&.Mui-disabled': {
                            color: '#9e9e9e',
                            opacity: 0.5,
                        }
					},
				}),
				required: getStyleOverrides({
					styles: {
						'.MuiInputLabel-asterisk': {
							display: 'none',
						},
					},
				}),
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: getStyleOverrides({
					styles: {
						'&.Mui-focused:not(.Mui-error)': {
							fieldset: {
								'&.MuiOutlinedInput-notchedOutline': {
									borderColor: 'textField.borderHovered',
								},
							},
						},
						legend: {
							width: '0px !important',
						},
					},
				}),
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: getStyleOverrides({
					styles: {
						backgroundColor: 'textField.background',
						'&:hover': {
							borderColor: 'textField.primary',
							WebkitBoxShadow:'0 0 0 40px #fff inset !important',
						},
						'&:focus': {
							borderColor: 'primary.main',
						},
						'&.Mui-disabled  fieldset': {
							color: '#9e9e9e',
							backgroundColor: '#f5f5f5',
							opacity:0.5
                    	},
						'& input::placeholder': {
							color: 'placeholder.primary',
							opacity: 1
						},
						fontSize:16
					},
				}),
			},
		},
	},
};
